module.exports = __webpack_public_path__ + "assets/img/c5.881632c2.png";